import React from 'react';
import { OfferCard } from '../OfferCard';
import { EcgLine } from '../EcgLine';
export function IntroOffer() {
  return <section className="relative overflow-hidden bg-navy-900 px-5 py-16 text-white md:py-24" aria-labelledby="intro-offer-title" data-id="element-238" data-mp="1bc5718dbvqie">
      <EcgLine animated beats={8} strokeClassName="stroke-pulse" className="absolute left-0 top-10 h-14 w-full opacity-30" data-id="element-239" data-mp="1gaf27iz1yr40" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-240" data-mp="no44qh6qt6bf">
        <h2 id="intro-offer-title" className="font-display text-3xl font-black leading-tight sm:text-5xl text-balance" data-id="element-241" data-mp="npoza6t24p9a">
          Get the Complete ECG Interpretation Blueprint™ for Just <span className="text-gold" data-id="element-242" data-mp="wnqx6dhhv1sc">$27 USD</span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-white/80" data-id="element-243" data-mp="11fsggjd2xsrv">
          Six educational volumes. Five specialized bonuses. One organized system for studying ECG interpretation.
        </p>
      </div>
      <div className="relative mt-10" data-id="element-244" data-mp="8yg0p876ftk0">
        <OfferCard ctaLabel="Get the complete ECG Blueprint now" data-id="element-245" data-mp="8xeoh0efd10p" />
      </div>
    </section>;
}